import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import DatePicker from '../../../components/fields/DatePicker/DatePicker';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import TextInput from '../../../components/fields/TextInput/TextInput';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import SessionFormDTO from '../../../dto/SessionFormDTO';
import { getCamerasData } from '../../Settings/reducer';
import { getZonesData } from '../../Zones/reducer';

export default function FilterForm(props) {
  const {
    onHide, getValues, register, reset, defaultValues, meta, control,
  } = props;
  const { cameraList = [] } = useSelector(getCamerasData);
  const { zones = [] } = useSelector(getZonesData);
  const intl = useIntl();
  const { formatMessage } = intl;

  const DTO = new SessionFormDTO();
  const attributes = DTO.getAttributesByName();
  const clear = () => {
    reset({ ...getValues(), ...defaultValues });
  };

  const save = () => {
    onHide();
  };

  const sessionTypeList = [
    { value: 0, name: formatMessage({ id: 'session.type.0' }) },
    { value: 1, name: formatMessage({ id: 'session.type.1' }) },
  ];

  const carTypeList = [
    { value: 0, name: 'L' },
    { value: 1, name: 'M' },
    { value: 1, name: 'N' },
    { value: 1, name: 'O' },
  ];
  const zoneOptionsList = zones.map(z => ({ value: z.id, name: z.name }));
  return (
    <Dialog
      className={classNames('full-filter')}
      onClose={save}
      open
    >
      <DialogTitle header={formatMessage({ id: 'filters' })} title={<Icons onClick={onHide} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content custom-scroll-theme">
        <form className="filter-content-wrapper">
          <FieldDTO
            control={control}
            component={DatePicker}
            dtoObject={attributes.date}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={DatePicker}
            dtoObject={attributes.date_start}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={DatePicker}
            dtoObject={attributes.date_end}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.session_type}
            variant="material"
            options={sessionTypeList}
            withLabel
          />
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={attributes.reg_number}
            variant="material"
            withLabel
          />
          <FieldDTO
            control={control}
            component={CheckBoxInputWithLabel}
            dtoObject={attributes.show_conditionally_recognized}
            variant="material"
            withLabel
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.car_type}
            variant="material"
            withLabel
            options={carTypeList}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.camera}
            variant="material"
            withLabel
            options={cameraList}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.zone}
            variant="material"
            withLabel
            options={zoneOptionsList}
          />
        </form>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-text">{formatMessage({ id: 'session.find' }, { count: meta.count })}</div>
        <div className="hff-footer-buttons">
          <Button className="hff-clear-show" onClick={save}>{formatMessage({ id: 'show' })}</Button>
          <Button className="hff-clear-data" variant="secondary" onClick={clear}>{formatMessage({ id: 'clear.all' })}</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
